// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import { ColumnsType } from "antd/es/table";
import { Select, SelectProps, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";

// Local Imports
import CustomTable from "../../../../components/custom-table/custom-table";
import CustomSearch from "../../../../components/custom-search/custom-search";
import WaitingApprovalService from "../../waiting-approval.service";
import KycReview from "../../../../models/kyc-review.model";
import { Status } from "../../../../models/enum";
import ReactCountryFlag from "react-country-flag";
import clsx from "clsx";
import { useSelector } from "react-redux";
import {
  ApprovalGroups,
  BUSINESS_ACCOUNT_BRANCH,
} from "../../../../utils/data/constant";
import moment from "moment";

let searchTimer = null;

const Processing: React.FC = (): ReactElement => {
  const witingApprovalService = new WaitingApprovalService();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);
  const loadingState = useSelector((state: any) => state?.loading);
  const [processingRequestsList, setProcessingRequestsList] = useState<any[]>(
    []
  );
  const [responseDate, setResponseDate] = useState<any>({});
  const [searchWord, setSearchWord] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  const options: SelectProps["options"] = [
    // {
    //   value: "View KYC PDF",
    //   label: (
    //     <div className="select-options flex align-center">
    //       <span>View KYC PDF</span>
    //     </div>
    //   ),
    // },
    {
      value: "View change list",
      label: (
        <div
          className="select-options flex align-center"
          onClick={() => navigate("/customers/view-history")}
        >
          <span>View changes list</span>
        </div>
      ),
    },
    {
      value: "Approval history",
      label: (
        <div
          className="select-options flex align-center"
          onClick={() => navigate("/customers/view-history")}
        >
          <span>Approval history</span>
        </div>
      ),
    },
    {
      value: "Lock record",
      label: (
        <div className="select-options flex align-center">
          <span>Lock record</span>
        </div>
      ),
    },
    {
      value: "Release record",
      label: (
        <div className="select-options flex align-center">
          <span>Release record</span>
        </div>
      ),
    },
  ];

  const handleActionChange = (
    value: string,
    kycReviewId: number,
    kycId: any = null,
    accountId: any = null,
    documentId: number
  ): void => {
    if (value === "Lock record") {
      lockKycReview(accountId, kycReviewId, kycId, documentId);
    } else if (value === "Release record") {
      releaseKycReview(kycReviewId);
    } else if (value === "View change list") {
      navigate(`/customers/change-list/${accountId}/${kycId}`);
    } else if (value === "Approval history") {
      navigate(`/customers/view-history/${accountId}`);
    }
  };

  const columns: ColumnsType<KycReview> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (_, __, index: number) => <span>{index + 1}</span>,
    },
    {
      title: "Full name",
      dataIndex: "nameEn",
      key: "nameEn",
      sorter: true,
      fixed: "left",
      render: (_, record) => (
        <span>{record?.kyc?.nameEn || record?.account?.activeKyc?.nameEn}</span>
      ),
    },
    {
      title: "Account #",
      dataIndex: "accountCode",
      key: "accountCode",
      width: 130,
      sorter: true,
      render: (_, record: KycReview) => (
        <Link
          to={`/home/business-account/${record.accountId}/${
            record.kycId || record?.account?.activeKycId
          }/details`}
        >
          {record?.account?.accountCode}
        </Link>
      ),
    },
    {
      title: "Nationality",
      dataIndex: "nationality",
      key: "nationality",
      render: (_, record: KycReview) => (
        <div className="flex align-center">
          <ReactCountryFlag
            style={{
              fontSize: "24px",
              marginInlineEnd: "8px",
            }}
            countryCode={
              record?.kyc?.nationality?.countryCode ||
              record?.account.activeKyc?.nationality?.countryCode
            }
            svg
          />
          <span>
            {record?.kyc?.nationality?.nationalityEn ||
              record?.account?.activeKyc?.nationality?.nationalityEn}
          </span>
        </div>
      ),
    },
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      render: (_, record: KycReview) => (
        <span>{BUSINESS_ACCOUNT_BRANCH[record?.account?.branch]}</span>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 110,
      render: (_, record: KycReview) =>
        record?.lockedById && record?.lockedById === user?.id ? (
          record?.accountDocumentsId && record?.kycId ? (
            <Link
              to={`/home/business-account/${record?.accountId}/${
                record?.kycId || record?.account?.activeKycId
              }/${record?.id}/${
                record?.accountDocumentsId || record?.account?.activeDocumentsId
              }/details?tab=1&approve=2`}
            >
              Full review
            </Link>
          ) : record.accountDocumentsId ? (
            <Link
              to={`/home/business-account/${record?.accountId}/${
                record?.kycId || record?.account?.activeKycId
              }/${record?.id}/${
                record?.accountDocumentsId
              }/details?tab=2&approve=2`}
            >
              Document
            </Link>
          ) : record.kycId ? (
            <Link
              to={`/home/business-account/${record?.accountId}/${
                record?.kycId
              }/${record?.id}/${
                record?.accountDocumentsId || record?.account?.activeDocumentsId
              }/details?tab=1&approve=1`}
            >
              KYC
            </Link>
          ) : (
            <span>
              {record?.accountDocumentsId && record?.kycId
                ? "Full Review"
                : record?.accountDocumentsId
                ? "Document"
                : "KYC"}
            </span>
          )
        ) : (
          <span>
            {record?.accountDocumentsId && record?.kycId
              ? "Full Review"
              : record?.accountDocumentsId
              ? "Document"
              : "KYC"}
          </span>
        ),
    },
    {
      title: "Version",
      dataIndex: "version",
      key: "version",
      render: (_, record: KycReview) => (
        <span>
          {record?.kyc?.version ||
            record?.accountDocuments?.version ||
            record?.account?.activeKyc?.version ||
            "New"}
        </span>
      ),
    },
    {
      title: "Locked by",
      dataIndex: "who",
      key: "who",
      width: 150,
      render: (_, record) => <span>{record?.lockedBy?.name}</span>,
    },
    {
      title: "Created at",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: true,
      width: 180,
      render: (text) => (
        <span className="flex justify-center text-gray-500">
          {moment(text).format("MMM DD YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Updated at",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: true,
      width: 180,
      render: (_, record) =>
        record?.feedback?.length ? (
          <span className="flex justify-center text-gray-500">
            {moment(
              record?.feedback[record?.feedback?.length - 1]?.reviewedAt
            ).format("MMM DD YYYY hh:mm A")}
          </span>
        ) : (
          "-"
        ),
    },
    {
      title: "Actions",
      key: "actions",
      width: "250px",
      render: (_, record) => (
        <div
          className="flex align-center"
          style={{ height: "25px !important" }}
        >
          <Select
            allowClear
            showSearch
            filterOption={(input, option: any) => {
              return (option?.value?.toLowerCase() ?? "").includes(
                input.toLowerCase()
              );
            }}
            value={null}
            options={getRecordActions(record)}
            style={{ width: "100%", height: "25px !important" }}
            onChange={(value: string) =>
              handleActionChange(
                value,
                record.id,
                record?.kycId || record?.account?.activeKycId,
                record.accountId,
                record?.accountDocumentsId || record?.account?.activeDocumentsId
              )
            }
            placeholder={<div className="flex">Select an action</div>}
          />
        </div>
      ),
    },
  ];

  const getRecordActions = (record: KycReview) => {
    let actions = [];
    if (record.locked) {
      actions = options.filter((option) =>
        record.lockedById === user?.id
          ? option.value !== "Lock record"
          : option.value !== "Lock record" && option.value !== "Release record"
      );
    } else {
      actions = options.filter((option) => option.value !== "Release record");
    }

    if (
      (record?.kyc?.version <= 1 && record?.account?.activeKyc?.version <= 1) ||
      !record?.account?.accountCode
    ) {
      actions = actions.filter((option) => option.value !== "View change list");
    }

    return actions;
  };

  useEffect(() => {
    fetchProcessingListData();
  }, [searchWord, sortField, sortOrder]);

  const fetchProcessingListData = async (page = 1): Promise<void> => {
    const data: any = await witingApprovalService.getKycReviewListData(
      [Status.Processing],
      page,
      searchWord,
      sortField,
      sortOrder
    );

    if (data !== undefined) {
      setResponseDate(data);
      setProcessingRequestsList(data?.reviews);
    }
  };

  const lockKycReview = async (
    accountId: number,
    kycReviewId: number,
    kycId: number,
    documentId: number
  ): Promise<void> => {
    const response = await witingApprovalService.lockKycReviewRecord(
      kycReviewId
    );
    navigate(
      `/home/business-account/${accountId}/${kycId}/${kycReviewId}/${documentId}/details?tab=1&approve=1`
    );
    if (response) {
      fetchProcessingListData();
    }
  };

  const releaseKycReview = async (kycReviewId: number): Promise<void> => {
    const response = await witingApprovalService.releaseKycReviewRecord(
      kycReviewId
    );
    if (response) {
      fetchProcessingListData();
    }
  };

  const onSearch = (e) => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      setSearchWord(e.target.value);
    }, 1000);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setSortField(sorter.field);
    setSortOrder(sorter.order);
  };

  return (
    <div className=" mt-5 border-t-[1px] border-gray-400 rounded-lg">
      <div className="flex items-center justify-between rounded-lg bg-white py-[10px] px-5">
        <p className=" text-black-300 text-base font-bold">
          {!loadingState ? processingRequestsList?.length : ""} Processing
          requests for{" "}
          {user?.kycReviewGroup
            ? `${ApprovalGroups[user?.kycReviewGroup]}`
            : ""}{" "}
        </p>
        <div className="flex items-center">
          <CustomSearch onChange={(event) => onSearch(event)} />
        </div>
      </div>
      {processingRequestsList?.length ? (
        <CustomTable
          columns={columns}
          data={processingRequestsList}
          showPagination={true}
          pageSize={responseDate?.pageSize}
          totalCount={responseDate?.totalCount}
          page={responseDate?.currentPage}
          handleTableChange={handleTableChange}
          onPageChange={(page) => {
            fetchProcessingListData(page);
          }}
        />
      ) : !loadingState ? (
        <div className="flex flex-col gap-3 w-full items-center justify-center mt-9">
          <img
            className="w-[40px] h-[40px]"
            src="/images/no-items.svg"
            alt="no data kamco"
          />
          <p className="text-lg text-gray-500 font-medium">
            There are no items in this list
          </p>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Processing;
